export const EditModal = ({
  isOpen,
  onClose,
  title,
  value,
  onChange,
  onSave,
  placeholder = 'Enter name',
  saveButtonText = 'Update',
  isLoading = false,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-100 p-4"
      style={{
        background: 'rgba(16, 24, 40, 0.70)',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
      }}
    >
      <div
        className="p-6 shadow-2xl w-[95%] sm:w-[440px] md:w-[460px] max-w-[95vw]"
        style={{
          background: 'var(--q3-surface-default)',
          borderRadius: '16px',
        }}
      >
        <h3 className="text-base font-semibold mb-3" style={{ color: 'var(--q3-neutral-default)' }}>
          {title}
        </h3>

        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full p-3 mb-5 text-sm rounded outline-none focus:border-[1px]"
          style={{
            border: '1px solid #D0D5DD',
            color: 'var(--q3-neutral-default)',
            borderRadius: '8px',
          }}
          onFocus={(e) => (e.target.style.border = '2px solid var(--q3-accent-normal)')}
          onBlur={(e) => (e.target.style.border = '1px solid #D0D5DD')}
          placeholder={placeholder}
        />

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            style={{
              borderRadius: '360px',
              padding: '8px 20px',
              background: 'transparent',
              color: 'var(--q3-neutral-default)',
              border: '1px solid #D0D5DD',
              cursor: 'pointer',
            }}
          >
            Cancel
          </button>

          <button
            onClick={onSave}
            disabled={isLoading}
            style={{
              borderRadius: '360px',
              padding: '8px 20px',
              background: 'var(--q3-accent-normal)',
              color: '#fff',
              opacity: isLoading ? 0.6 : 1,
              cursor: isLoading ? 'not-allowed' : 'pointer',
            }}
          >
            {isLoading ? 'Saving...' : saveButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};
